import React, { useState, useLayoutEffect } from 'react'


const SubmenuList = (props) => {
   const { subMenuList } = props;

   // const [windWidth, winHeight] = useWindowSize();

   return (
      <div className='accordionContent'>
         <ul className='subMenu'>
            {
               subMenuList.map((list) => {
                  return (
                     <li key={Math.random()}  defaultChecked={true} className={`subMenuBtn ${list.menuType}`} id={`menu_id_${list.id}`} onKeyDown={(e) => {
                        if (e.key !== 'Enter') {
                           return
                        } props.handleMenuClick(list)
                     }} onClick={(event) => {
                        props.handleMenuClick(list,event)
                     }} >
                        {list.menuType === "radioButton" ? <label>
                           <input type={'radio'} value={'product1'} name={list.selectConfiguration} />
                           <span id="tower_tab">  {list.title}</span>
                        </label>
                           : ((window.mob || window.innerHeight > window.innerWidth) && props.orentation === 0) || window.innerWidth < 935 ?
                           <>
                              <div className='accordia_icon'>
                                 <img className='arrow' src='images/spacer.png' id={`accordianIcon_${list.id}`} />
                              </div>
                              {list.title}
                              </>
                              : list.title}
                        {((window.mob || window.innerHeight > window.innerWidth) && list.content && props.orentation === 0) || window.innerWidth < 935 ?
                         list.content && list.content.length>0 &&   <div id="" className="hotspots_div">
                              <ol type="1" style={{ listStyleType:'decimal'}} >
                                 {list.content && list.content.map((child) => (
                                    <li key={Math.random()}>{child.text}</li>
                                 ))
                                 }
                              </ol>
                           </div>
                           : null
                        }
                        {((window.mob ||window.innerHeight > window.innerWidth) && list.content && props.orentation === 0) || window.innerWidth < 935 ?
                         list.content1 && list.content1.length>0 &&   <div id="declaimer" className="hotspots_div">
                              <ol type="1" >
                                 {list.content1 && list.content1.map((child) => (
                                    <li key={Math.random()}>{child.text1}</li>
                                 ))
                                 }
                              </ol>
                           </div>
                           : null
                        }
                     </li>
                  )
               })
            }

         </ul>
      </div>
   )
}

export default SubmenuList